<template>
  <div class="modules" v-if="GET_MOUNTED_COURSE.mounted_curses">
    <div
      v-for="data in GET_MOUNTED_COURSE.mounted_curses.modules"
      :key="data.id"
    >
      <ModulesBox :item="data"></ModulesBox>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModulesBox from "../components/ModulesBox.vue";

export default {
  components: {
    ModulesBox,
  },
  data() {
    return {
      mounted_courses: [],
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("detailCourse", ["GET_MOUNTED_COURSE"]),
  },
  watch: {
    GET_MOUNTED_COURSE() {

      let id = ''
      let resourceSelect = ''
      if(this.$route.params.resource== undefined){
        id = this.GET_MOUNTED_COURSE.mounted_curses.modules[0].lessons[0].resources[0].id
        this.$router.push({ 
          name: "v2-course-detail", 
          params: { 
            id: this.GET_MOUNTED_COURSE.mounted_curses.id,
            resource: id,
          },
        })
        resourceSelect = this.GET_MOUNTED_COURSE.mounted_curses.modules[0].lessons[0] .resources[0]
      }
      else {
        id = this.$route.params.resource
        let resource = ''
        this.GET_MOUNTED_COURSE.mounted_curses.modules.forEach(module => {
          module.lessons.forEach(lesson => {
            resource = lesson.resources.find(resource => resource.id === parseInt(id))
            if(resource!==undefined)
              resourceSelect = resource
          })
        })
      }

      this.$store.commit(
        "detailCourse/SET_LESSON", resourceSelect
      );
    },
  },
};
</script>
